const roles = [
  { role: 1, description: "quest" },
  { role: 2, description: "admin" },
  { role: 3, description: "user" },
];

const roleArr = {
  notAuth: [1],
  isAuth: [2, 3],
  admin: [2],
  isAdmin: [2]
};

/* role pages */
const rolePageArr = {
  HomePage: [1, 2, 3],
  ErrorPage: [1, 2, 3],
  Error404: [1, 2, 3],
  TosPage: [1,2,3],
  PrivacyPage: [1,2,3],
  CookiePolicyPage: [1,2,3],
  ContactPage: [1,2,3],

  UsersHome: [2, 3],
  UsersSignIn: [1,2,3],
  UsersUpdate: [],
  UsersDetail: [2, 3],
  UsersList: [2],
  UsersSearch: [2],
  UsersLogin: [1,2,3],
  UsersForgotPassword: [1,2,3],
  UsersLogout: [2, 3],

  SchemaHome: [],
  SchemaCreate: [],
  SchemaUpdate: [],
  SchemaDetail: [],
  SchemaList: [],
  SchemaSearch: [],
  ContactsHome: [],
  ContactsCreate: [], 
  ContactsUpdate: [], 
  ContactsDetail: [], 
  ContactsList: [], 
  ContactsSearch: [], 
  
  TasksHome: [2, 3],
  TasksCreate: [2, 3],
  TasksUpdate: [2, 3],
  TasksDetail: [2, 3],
  TasksList: [2, 3],
  TasksSearch: [],
  KanbanBoard: [],
  CalendarView: [],
  MermaidHome: [],
  MermaidCreate: [],
  MermaidUpdate: [],
  MermaidDetail: [],
  MermaidList: [],
  MermaidSearch: [],

  // Admin pages
  AdminHome: [],
  AdminSettings: [],
  AdminSiteSettings: [],
  AdminUsers: [],
  AdminAnalytics: [],
  AdminLogs: [],
  AdminSchema: [],
  AdminSchemaCreate: [],
  AdminSchemaUpdate: [],
  AdminSchemaDetail: [],
  AdminContacts: [],
  DockerInfo: [],
  QuestionsHome: [2],
  QuestionsCreate: [], 
  QuestionsUpdate: [], 
  QuestionsDetail: [2, 3], 
  QuestionsList: [2, 3], 
  QuestionsSearch: [2, 3], 
  ExamsHome: [2, 3],
  ExamsCreate: [], 
  ExamsUpdate: [2,3], 
  ExamsDetail: [2, 3], 
  ExamsList: [2, 3], 
  ExamsSearch: [2, 3], 
  ExamsDetailMyExams: [2, 3],
  ExamsSolve: [1, 2, 3],
  ExamsAnswers: [1, 2, 3],

  
  LoginFirebaseToken: [1,2,3],
  AiHome: [2],
  AiCreate: [2], 
  AiUpdate: [2], 
  AiDetail: [2], 
  AiList: [2], 
  AiSearch: [2, 3], 
  SinifHome: [2, 3],
  SinifCreate: [1, 2, 3], 
  SinifUpdate: [2, 3], 
  SinifDetail: [2, 3], 
  SinifList: [2, 3], 
  SinifSearch: [2, 3], 
  DersHome: [2, 3],
  DersCreate: [1, 2, 3], 
  DersUpdate: [2, 3], 
  DersDetail: [2, 3], 
  DersList: [2, 3], 
  DersSearch: [2, 3], 
  UnitsHome: [2, 3],
  UnitsCreate: [1, 2, 3], 
  UnitsUpdate: [2, 3], 
  UnitsDetail: [2, 3], 
  UnitsList: [2, 3], 
  UnitsSearch: [2, 3], 
  empty: [],
};

export default { ...roleArr, ...rolePageArr };
export { roles };
